import { InputBase, TextField, Typography, makeStyles, withStyles } from "@material-ui/core";

export const LeftSideV2Styles = makeStyles((theme) => ({
  primaryButton: {
    textTransform: "none",
    background: "#3e50f7",
    "&:hover, &:focus": {
      background: "#3e50f7",
    },
  },

  closeButton: {
    textTransform: "none",
    color: "#ffffff",
    background: "var(--red)",
    "&:hover, &:focus": {
      background: "var(--red)",
    },
  },
}));

export const BasicInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
    "&.MuiInputBase-multiline": {
      padding: "0 !important",
    },
  },
  input: {
    position: "relative",
    color: "var(--dark_blue)",
    fontSize: "14px !important",
    margin: "0 !important",
    height: "2.5rem !important",
    padding: "10px 12px 10px  !important",
    borderRadius: "4px !important",
    border: "1px solid #ced4da !important",
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 4,
      boxShadow: "unset !important",
    },
  },
}))(InputBase);

export const BasicInputSelect = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    position: "relative",
    color: "var(--dark_blue)",
    fontSize: ".8vw",
    margin: "0 !important",
    padding: "10px 12px 10px  !important",
    borderRadius: "4px !important",
    border: "1px solid #ced4da !important",
    transition: theme.transitions.create(["border-color", "box-shadow"]),

    "&:focus": {
      borderRadius: 4,
      boxShadow: "unset !important",
    },
  },
}))(InputBase);

export const BasicTextField = withStyles((theme) => ({
  root: {
    "& .MuiInputBase-root": {
      padding: "0 !important",
      "& .MuiInputBase-input": {
        position: "relative",
        color: "var(--dark_blue)",
        fontSize: "14px !important",
        margin: "0 !important",
        height: "2.5rem !important",
        borderRadius: "4px !important",
        border: "1px solid #ced4da !important",
        transition: theme.transitions.create(["border-color", "box-shadow"]),

        "&:focus": {
          borderRadius: 4,
          boxShadow: "unset !important",
        },
      },
    },
  },
}))(TextField);

export const BasicFormLabel = withStyles((theme) => ({
    root: {
        color: "var(--dark_blue) !important",
        fontSize: "14px !important",
        fontWeight: "600 !important",
        marginBottom: "4px !important",
        height: "unset !important"
    }
}))(Typography);